import type { IDomainCoordinate } from "~/domain/coordinate";

export const isUsableCoordinate = (
  coordinate?: Partial<IDomainCoordinate>,
): boolean =>
  Number.isFinite(coordinate?.lat) &&
  Number.isFinite(coordinate?.lng) &&
  !(coordinate?.lat === 0 && coordinate?.lng === 0);
